export default class Scroll {
    constructor() {
        function checkElementLocation() {
            var windowScrollTop = window.scrollY;
            var windowHeight = window.innerHeight;
            var elements = document.querySelectorAll(".elem");

            elements.forEach(function(element) {
                var elementTop =
                    element.getBoundingClientRect().top + windowScrollTop;
                var elementHeight = element.offsetHeight;

                // Check if any part of the element is visible in the viewport
                if (
                    elementTop + elementHeight >= windowScrollTop &&
                    elementTop <= windowScrollTop + windowHeight
                ) {
                    element.classList.add("fade-in");
                }
            });
        }

        // If any part of the element is in the viewport, show the animation
        checkElementLocation();

        window.addEventListener("scroll", function() {
            checkElementLocation();
        });
    }
}
